import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InterceptorErrorComponent } from './pages/interceptor-error/interceptor-error.component';
import { CheckoutUrlRedirectionComponent } from './pages/checkout-url-redirection/checkout-url-redirection.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { TreatmentPolicyComponent } from './pages/treatment-policy/treatment-policy.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'provider',
    loadChildren: () => import('./modules/admin/client.module').then(m => m.ClientModule),
  },
  {
    path: 'error',  // Nueva ruta explícita para la página de error
    component: InterceptorErrorComponent,
  },
  { path: 'payments/result', component: CheckoutUrlRedirectionComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'treatment-policy', component: TreatmentPolicyComponent },
  {
    path: '**',
    redirectTo: '/error',  // Redirige a la página de error en caso de ruta no encontrada
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
